import { render, staticRenderFns } from "./oncallGroupSetting.vue?vue&type=template&id=1dc63667&"
import script from "./oncallGroupSetting.vue?vue&type=script&lang=ts&"
export * from "./oncallGroupSetting.vue?vue&type=script&lang=ts&"
import style0 from "./oncallGroupSetting.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports